import './main.scss';

import { CollapseComponent } from '@opten/collapse';
import { factory } from '@opten/compiler/factory';
import { Component } from '@opten/compiler/metadata/component';
import { debounce } from '@opten/reactive/debounce';

import { CookieBanner } from './components/cookie-banner';
import { CountdownComponent } from './components/countdown/countdown';
import { DetailSliderCustom } from './components/detail-slider';
import filterpage from './components/filterpage';
import { MapInteractiveComponent } from './components/map-interactive';
import { Navbar } from './components/navbar';
import { SelectComponent } from './components/select';
import { Shopfinder } from './components/shopfinder';
import { SliderCustom } from './components/slider';
import { SpecialButton } from './components/special-button';
import { StickyComponent } from './components/sticky';
import { StickyFooter } from './components/sticky-footer';
import { SubscribeComponent } from './components/subscribe';
import { FadeText } from './components/fade-text';

@Component({ className: 'js-filter__page' })
class FilterPage {
	constructor(private element: HTMLElement) {
		filterpage(element);
	}
}

factory([
	CollapseComponent,
	CookieBanner,
	SliderCustom,
	DetailSliderCustom,
	SelectComponent,
	StickyComponent,
	StickyFooter,
	SpecialButton,
	SubscribeComponent,
	Navbar,
	FilterPage,
	Shopfinder,
	CountdownComponent,
	MapInteractiveComponent,
	FadeText
])(document.body);

setViewportHeight();
window.addEventListener(
	'resize',
	debounce(() => {
		setViewportHeight();
	}, 100)
);

function setViewportHeight() {
	// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
	const vh = window.innerHeight * 0.01;
	// Then we set the value in the --vh custom property to the root of the document
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}
